/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
declare const _IgnoredTombstoneOrHideContainer_viewer$ref: unique symbol;
export type IgnoredTombstoneOrHideContainer_viewer$ref = typeof _IgnoredTombstoneOrHideContainer_viewer$ref;
export type IgnoredTombstoneOrHideContainer_viewer = {
    readonly ignoredUsers: ReadonlyArray<{
        readonly id: string;
    }>;
    readonly " $refType": IgnoredTombstoneOrHideContainer_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "IgnoredTombstoneOrHideContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "ignoredUsers",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "id",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '86b42da1a3c713be301c0c1a67dbf950';
export default node;
